export const CARD_TYPES = [
     {
          name: 'MasterCard',
          regexPrefix: /^(?:5[1-5]|222[1-9]|22[3-9][0-9]|2[3-6]|27[01][0-9]|2720)[0-9]*$/,
          inputMask: '9999 9999 9999 9999',
          inputPlaceholder: '0000 0000 0000 0000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '**** **** **** ',
          imageSrc: '/assets/images/cards/card-master-card.svg',
     },
     {
          name: 'Maestro',
          regexPrefix: /^(?:5(?:0|[6-8])|6(?:1|[8-9]))[0-9]*$/,
          inputMask: '9999 9999 9999 9999',
          inputPlaceholder: '0000 0000 0000 0000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '**** **** **** ',
          imageSrc: '/assets/images/cards/card-maestro.svg',
     },
     {
          name: 'Diners Club',
          regexPrefix: /^3(?:0(?:[0-5]|95)|[8-9])[0-9]*$/,
          inputMask: '99999 9999 9999999',
          inputPlaceholder: '00000 0000 0000000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '***** **** ***',
          imageSrc: '/assets/images/cards/card-diners.svg',
     },
     {
          name: 'JCB',
          regexPrefix: /^(?:2131|1800|35)[0-9]*$/,
          inputMask: '9999 9999 9999 9999',
          inputPlaceholder: '0000 0000 0000 0000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '**** **** **** ',
          imageSrc: '/assets/images/cards/card-jcb.svg',
     },
     {
          name: 'Discover',
          regexPrefix: /^6(?:01[13]|5)[0-9]*$/,
          inputMask: '9999 9999 9999 9999',
          inputPlaceholder: '0000 0000 0000 0000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '**** **** **** ',
          imageSrc: '/assets/images/cards/card-discover.svg',
     },
     {
          name: 'Diners Club',
          regexPrefix: /^2(?:014|149)[0-9]*$/,
          inputMask: '99999 9999 999999',
          inputPlaceholder: '00000 0000 000000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '***** **** **',
          imageSrc: '/assets/images/cards/card-diners.svg',
     },
     {
          name: 'Diners Club',
          regexPrefix: /^5[4-5][0-9]*$/,
          inputMask: '9999 9999 9999 9999',
          inputPlaceholder: '0000 0000 0000 0000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '**** **** **** ',
          imageSrc: '/assets/images/cards/card-diners.svg',
     },
     {
          name: 'American Express',
          regexPrefix: /^3[47][0-9]*$/,
          inputMask: '9999 999999 99999',
          inputPlaceholder: '0000 000000 00000',
          cvcMask: '9999',
          cvcPlaceholder: '0000',
          cardMask: '**** ****** *',
          imageSrc: '/assets/images/cards/card-amex.svg',
     },
     {
          name: 'Diners Club',
          regexPrefix: /^36[0-9]*$/,
          inputMask: '99999 99999 9999',
          inputPlaceholder: '00000 00000 0000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '***** ***** ',
          imageSrc: '/assets/images/cards/card-diners.svg',
     },
     {
          name: 'UnionPay',
          regexPrefix: /^62[0-9]*$/,
          inputMask: '9999 9999 9999 9999',
          inputPlaceholder: '0000 0000 0000 0000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '**** **** **** ',
          imageSrc: '/assets/images/cards/card-unionpay.svg',
     },
     {
          name: 'Visa',
          regexPrefix: /^4[0-9]*$/,
          inputMask: '9999 9999 9999 9999',
          inputPlaceholder: '0000 0000 0000 0000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '**** **** **** ',
          imageSrc: '/assets/images/cards/card-visa_new.svg',
     },
     {
          name: 'Other',
          inputMask: '9999 9999 9999 9999',
          inputPlaceholder: '0000 0000 0000 0000',
          cvcMask: '999',
          cvcPlaceholder: '000',
          cardMask: '**** **** **** ',
          imageSrc: '',
     },
];
